import React, { createContext, useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import axios from 'axios';

export const AssetContext = createContext();

export const AssetProvider = ({ children }) => {
  const [assets, setAssets] = useState([]);
  const [defects, setDefects] = useState([]);

  const saveDefectsToExcel = async (updatedDefects) => {
    try {
      console.log('Saving defects:', updatedDefects.length, 'items');
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(updatedDefects);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Defects');
      const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const formData = new FormData();
      formData.append('file', blob, 'defect_list.xlsx');
      
      const response = await axios.post("/api/upload-defects", formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true  // Add this for cookie auth
      });
      console.log('Save response:', response.data);
      return true;
    } catch (error) {
      console.error('Error saving defect list:', error.response?.data || error.message);
      return false;
    }
  };

  // Load asset data
  useEffect(() => {
    const loadAssetData = async () => {
      try {
        const response = await fetch('/data/asset_list.xlsx');
        if (!response.ok) throw new Error('Error loading Excel file');
        const data = await response.arrayBuffer();
        const workbook = XLSX.read(data);
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        setAssets(jsonData);
      } catch (error) {
        console.error('Error loading asset list:', error);
      }
    };
    loadAssetData();
  }, []);

  // Load defect data - USE RELATIVE URL
  useEffect(() => {
    const loadDefectData = async () => {
      try {
        const response = await fetch('/api/defects', {
          credentials: 'include'  // Add this for cookie auth
        });
        if (!response.ok) throw new Error('Error loading defects');
        const data = await response.arrayBuffer();
        const workbook = XLSX.read(data);
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        setDefects(jsonData);
      } catch (error) {
        console.error('Error loading defect list:', error);
      }
    };
    loadDefectData();
  }, []);

  return (
    <AssetContext.Provider value={{ assets, defects, setDefects, saveDefectsToExcel }}>
      {children}
    </AssetContext.Provider>
  );
};